import { EntityVm } from 'api/core/entity.vm';
import { IsString } from 'class-validator';

export class AsrsServerProductVm extends EntityVm {
  @IsString()
  id: string;

  @IsString()
  sku: string;

  @IsString()
  optionalCode: string;

  @IsString()
  name: string;

  @IsString()
  measureUnit: string;
}
